import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';
import { NodeBuilder } from '../../../../../../../shared/models';
import { DateFormat, NODE_TYPE } from './dateFormat';
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { ClickatellFormValidationComponent } from '../../../../../../../shared/components/clickatell-form-validation/clickatell-form-validation.component';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { CMSComponent } from '../../../../../../../shared/components/cms/cms.component';
import { NextSelectorComponent } from '../../../../json-to-from/next-selector/next-selector.component';

@Component({
    selector: 'app-date-format',
    templateUrl: './date-format.component.html',
    styleUrls: ['./date-format.component.scss'],
    imports: [ReactiveFormsModule, ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ClickatellFormValidationComponent, ActiveFormDirective, CMSComponent, NextSelectorComponent]
})
export class DateFormatComponent extends NodeBuilder implements OnInit {

  dateFormatForm: UntypedFormGroup;

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
  }

  set buildForm(stepData: { [index: string]: any }) {
    this.dateFormatForm = DateFormat.toForm(stepData, this.canEdit);

    if (this.dateFormatForm.get('yes').value === newStepValue) {
      this.dateFormatForm.get('yes').setValue('step' + this.getNextStep());
    }
    if (this.dateFormatForm.get('no').value === newStepValue) {
      this.dateFormatForm.get('no').setValue('step' + this.getNextStep());
    }
  }

  get getStepData(): {} {
    const formData = this.dateFormatForm.getRawValue();
    return new DateFormat(formData).nodeData;
  }

  get isNodeValid(): boolean {
    this.dateFormatForm.markAllAsTouched();
    return this.dateFormatForm.valid;
  }

}
